// Package Imports
import { notification } from 'antd';
import getNotificationColors from 'core/utils/getNotificationColors';
import { CloseOutlined } from '@ant-design/icons';

export type NotificationType = 'success' | 'info' | 'warning' | 'error';

notification.config({
  getContainer: () => document.getElementById('root') as HTMLElement,
});

const openNotificationWithIcon = (
  type: string | NotificationType,
  message: any,
  description?: any,
  duration: number = 4.5 // Default duration of 4.5 seconds (between 2-5)
) => {
  let desc: React.ReactNode = description;

  if (description) {
    const parts = description
      .split('|')
      .map((part, index) => <p key={index}>{part}</p>);
    desc = parts;
  }

  const { borderColor, backgroundColor } = getNotificationColors(type);
  const notificationBorderStyle = {
    border: `1px solid ${borderColor}`,
    backgroundColor,
  };

  notification[type]({
    message,
    description: desc,
    style: {
      ...notificationBorderStyle,
      borderRadius: '6px',
    },
    duration, // Auto-close after specified duration
    closeIcon: <CloseOutlined />, // Custom close icon
  });
};

export default openNotificationWithIcon;
